const SUPPRESS_AUTO_LOGIN_KEY = 'hsPoker.suppressAutoLogin';

export const suppressAutoLoginForSession = () => {
    try {
        sessionStorage.setItem(SUPPRESS_AUTO_LOGIN_KEY, '1');
    } catch {}
};

export const clearAutoLoginSuppression = () => {
    try {
        sessionStorage.removeItem(SUPPRESS_AUTO_LOGIN_KEY);
    } catch {}
};

export const shouldSuppressAutoLogin = (): boolean => {
    try {
        return sessionStorage.getItem(SUPPRESS_AUTO_LOGIN_KEY) === '1';
    } catch {
        return false;
    }
};

export const removeAuthTokenFromUrl = () => {
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('token')) return;
        url.searchParams.delete('token');
        const nextUrl = `${url.pathname}${url.search}${url.hash}`;
        window.history.replaceState({}, document.title, nextUrl);
    } catch {}
};
